<template>
    <div class="user-role-view" v-loading="loading">
        <div class="row">

            <div class="col-md-4 mb-2">
                <el-button type="primary" @click="blukDelete" v-if="rights.delete">Bulk Delete</el-button>
                <el-button type="primary" @click="page.openDialog = true" v-if="rights.add">Add User</el-button>

                <el-dialog
                    title="User"
                    :visible.sync="page.openDialog"
                    width="50%"
                    :before-close="handleDialogClose"
                    v-loading="page.dialogLoding">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">

                                <el-form ref="userForm" :model="page.form" :rules="page.formRules" label-width="150px">

                                    <el-form-item label="Name" prop="name">
                                        <el-input v-model="page.form.name" ref="name"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Username" prop="username">
                                        <el-input v-model="page.form.username" ref="username"></el-input>
                                    </el-form-item>

                                    <el-form-item label="Password" prop="password" v-if="!page.formBtnUpdate">
                                        <el-input type="password" v-model="page.form.password" ref="password"></el-input>
                                    </el-form-item>
                                    
                                    <el-form-item label="Select Role" prop="role">
                                        <el-autocomplete
                                            v-model="page.form.role"
                                            :fetch-suggestions="roleSearch"
                                            @select="roleSelect"
                                            ref="role"
                                        ></el-autocomplete>
                                    </el-form-item>

                                    <el-form-item>
                                        <el-button type="primary" @click="submitData" v-if="page.formBtnSubmit">Submit</el-button>
                                        <el-button type="primary" @click="resetData('userForm')" v-if="page.formBtnSubmit">Reset</el-button>
                                        <el-button type="primary" @click="updateData" v-if="page.formBtnUpdate">Update</el-button>
                                    </el-form-item>

                                </el-form>

                            </div>
                        </div>

                    </span>
                </el-dialog>
            </div>

            <div class="col-md-4 mb-2">
            </div>

            <div class="col-md-4 mb-2">
                <el-input v-model="table.search" placeholder="Search By Name" v-if="rights.view" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="table.tableData.filter(data => !table.search || data.name.toLowerCase().includes(table.search.toLowerCase()))"
                    :default-sort = "{prop: 'enquiry_date', order: 'descending'}"
                    style="width: 100%"
                    v-loading="table.loading"
                    @selection-change="handleSelectionChange"
                    v-if="rights.view">
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>

                    <el-table-column label="Name" prop="name" sortable> </el-table-column>
                    <el-table-column label="Username" prop="username" sortable> </el-table-column>
                    <el-table-column label="User Role" prop="user_role" sortable> </el-table-column>

                    <el-table-column
                        v-if="rights.edit || rights.delete"
                        align="right">
                        <template slot="header" slot-scope="scope">
                            Action
                        </template>
                        <template slot-scope="scope">
                            <el-button
                            v-if="rights.edit"
                            size="mini"
                            @click="handleEditClick(scope.$index, scope.row)">Edit</el-button>
                            <el-button
                            v-if="rights.delete"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="pagination.perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
export default {
    data () {

        const validName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Role'))
            } else {
                callback()
            }
        }

        const validUserName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Username'))
            } else {
                callback()
            }
        }

        const validPassword = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the Password'))
            } else {
                callback()
            }
        }

        const validRole = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please Select the Role'))
            } else {
                callback()
            }
        }
        return {
            loading: true,
            rights: {
                page: true,
                view: false,
                add: false,
                edit: false,
                delete: false,
                bulk_delete: false
            },
            page: {
                openDialog: false,
                dialogLoding: false,
                form: {
                    u_id: 0,
                    name: '',
                    username: '',
                    password: '',
                    r_id: '',
                    role: '',
                    user_role: [],
                },
                formRules: {
                    name: [{ required: true, trigger: 'blur', validator: validName }],
                    username: [{ required: true, trigger: 'blur', validator: validUserName }],
                    password: [{ required: true, trigger: 'blur', validator: validPassword }],
                    role: [{ required: true, trigger: 'change', validator: validRole}]
                },
                formBtnSubmit: true,
                formBtnUpdate: false,
                formValid: false
            },
            table: {
                search: '',
                loading: true,
                multipleSelection: [],
                tableData: []
            },
            pagination: {
                currentPage: 1,
                perPageItem: 100,
                totalData: 0
            }
        }
    },
    methods: {
        // Role Selection on form
        createFilter(queryString) {
            return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        roleSearch(queryString, cb) {
            var links = this.page.form.user_role;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            // call callback function to return suggestions
            cb(results);
        },
        roleSelect(item) {
            this.page.form.role = item.value
            this.page.form.r_id = item.link
        },
        // Get Role for dropdown
        getRole() {
            this.loading = true
            this.$axios.post("user-role/get.php" , {
                pageSize: 0,
                page: 0
            },{
                headers: generateHeader("userRoleData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    for(var i =0 ; i< response.data.extra.totalData; i++){
                        this.page.form.user_role.push({
                            "value":response.data.body[i].user_role , "link": response.data.body[i].r_id
                        })
                    }
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        //Dialog Close Event
        handleDialogClose(done) {
            this.$confirm('Are you sure to close this dialog?')
            .then(_ => {
                this.resetData('userForm')
                done();
            })
            .catch(_ => {});
        },
        handleFormValid(formRef){
            this.$refs[formRef].validate((valid) => {
                if(valid){
                    this.page.formValid = true
                    if(this.page.form.r_id == ""){
                        this.page.formValid = false    
                    }
                }
                else{
                    this.page.formValid = false
                }
            });
        },
        //Page Size
        handleSizeChange(val) {
            this.pagination.perPageItem = val
            this.getData()
        },
        //Current Page
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getData()
        },
        //Multi Select
        handleSelectionChange(val){
            this.table.multipleSelection = val
        },
        //Single row Edit
        handleEditClick(index, row) {
            this.page.form.u_id = row.u_id
            this.page.form.name = row.name
            this.page.form.username = row.username
            this.page.form.password = row.password
            this.page.form.r_id = row.r_id
            this.page.form.role = row.user_role
            
            this.page.formBtnSubmit = false
            this.page.formBtnUpdate = true

            this.page.openDialog = true
        },
        getRights() {
            this.loading = true
            this.$axios.post('user/rights.php' , {} , {
                headers: generateHeader("userRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.user_page == 1 ? true : false
                    // Rights
                    this.rights.add = response.data.body.rights.user_add == 1 ? true : false
                    this.rights.view = response.data.body.rights.user_view == 1 ? true : false
                    this.rights.edit = response.data.body.rights.user_edit == 1 ? true : false
                    this.rights.delete = response.data.body.rights.user_delete == 1 ? true : false
                    this.rights.bulk_delete = response.data.body.rights.user_bulk_delete == 1 ? true : false

                    this.getRole();
                    this.getData();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        getData() {
            this.table.loading = true
            this.$axios.post("user/get.php" , {
                pageSize: this.pagination.perPageItem,
                page: this.pagination.currentPage
            },{
                headers: generateHeader("userData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    this.table.tableData = response.data.body
                    this.pagination.totalData = parseInt(response.data.extra.totalData)
                }
                else if(response.data.code == "404"){
                    this.table.tableData = []
                    this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.table.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.table.loading = false
            })
        },
        submitData(){
            this.handleFormValid("userForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("user/add.php", this.page.form, {
                    headers: generateHeader("UserAdd")
                })
                .then((response) => {
                    if(response.data.code == "201"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('userForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                   
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        updateData() {
            this.handleFormValid("userForm")
            if(this.page.formValid){
                this.page.dialogLoding = true

                this.$axios.post("user/update.php", this.page.form, {
                    headers: generateHeader("userEdit")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.resetData('userForm')
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.page.dialogLoding = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error                    
                    });
                    this.page.dialogLoding = false
                })
                this.page.openDialog = false
            }
        },
        //Single row Delete
        handleDelete(index, row) {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {

                this.$axios.post('user/delete.php' , {
                    id: row.u_id
                }, {
                    headers: generateHeader("userDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
            })
        },
        // Bluk Delete
        blukDelete() {
            this.$confirm('Are you sure you want to delete ?' , 'Warning' , {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {
                this.$axios.post('user/bulk-delete.php' , {
                    data: this.table.multipleSelection
                }, {
                    headers: generateHeader("userDelete")
                })
                .then((response) => {
                    if(response.data.code == "205"){
                        this.$notify.success({
                            title: 'Success',
                            message: response.data.extra.message
                        });
                        this.getData()
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            })
            .catch(() => {
                this.$notify.info({
                    title: 'Info',
                    message: "Delete Cancle !!!"
                });
            })
        },
        resetData(formName){
            // this.$refs[formName].resetFields();
            this.page.form.name = ""
            this.page.form.username = ""
            this.page.form.r_id = ""
            this.page.form.password = ""
            this.page.form.u_id = 0
            this.page.form.role = ""
            this.page.formBtnSubmit= true
            this.page.formBtnUpdate= false
            this.page.formValid= false
        }
    },
    mounted() {
        this.getRights()
        // this.getRole()
    }
}

</script>


<style>
    .el-autocomplete{
        width: 100%;
    }
</style>